export default __webpack_public_path__ + "static/media/team3.efd89725.JPG";